/**
 * The wandering rares (ADR 0094): one named creature per biome, unique in
 * the world, that now and then stands up at a den of its region drawn by
 * the server, and leaves again if nobody finds it. The kin of one of the
 * region's creatures, drawn with its body; their stat blocks are derived in
 * `mobs.ts` (`RARE_SCALING`), their loot in `loot.ts` (`RARE_MOB_LOOT`).
 * Only what names them lives here, so `mobs.ts` and `items.ts` can both
 * read it.
 */
export const RARE_MOB_IDS = [
    'russet-vixen',
    'blackbark',
    'old-mossback',
    'red-stinger',
    'frostplume',
];
export const RARE_MOBS = Object.freeze({
    'russet-vixen': {
        kin: 'fox',
        biome: 'meadow',
        name: 'Roussette',
        epithet: 'la vieille renarde des blés',
        trophy: 'russet-brush',
    },
    blackbark: {
        kin: 'treant',
        biome: 'forest',
        name: 'Écorce-Noire',
        epithet: 'le sylvain errant',
        trophy: 'blackbark-heart',
    },
    'old-mossback': {
        kin: 'caiman',
        biome: 'swamp',
        name: 'Vieille-Mousse',
        epithet: 'le caïman ancestral',
        trophy: 'mossback-tooth',
    },
    'red-stinger': {
        kin: 'scorpion',
        biome: 'desert',
        name: 'Dard-Rouge',
        epithet: 'le scorpion-roi',
        trophy: 'red-stinger-sting',
    },
    frostplume: {
        kin: 'snow-harpy',
        biome: 'snow',
        name: 'Plume-de-Givre',
        epithet: 'la harpie solitaire',
        trophy: 'frostplume-quill',
    },
});
/**
 * Each trophy: a keepsake of the hunt, bound to nobody, one to a slot so a
 * bag shows each one apart. It sells for little: what it is worth is the
 * story, not the gold. Its icon is its kin's material until it has its own.
 */
export const RARE_TROPHY_TEMPLATES = [
    {
        id: 'russet-brush',
        name: 'Queue de Roussette',
        icon: 'icon.fox-tail',
        sellPrice: 15,
    },
    {
        id: 'blackbark-heart',
        name: 'Cœur d’Écorce-Noire',
        icon: 'icon.treant-bark',
        sellPrice: 30,
    },
    {
        id: 'mossback-tooth',
        name: 'Dent de Vieille-Mousse',
        icon: 'icon.caiman-tooth',
        sellPrice: 45,
    },
    {
        id: 'red-stinger-sting',
        name: 'Dard de Dard-Rouge',
        icon: 'icon.scorpion-stinger',
        sellPrice: 60,
    },
    {
        id: 'frostplume-quill',
        name: 'Rémige de Plume-de-Givre',
        icon: 'icon.harpy-feather',
        sellPrice: 80,
    },
].map((trophy) => ({ ...trophy, kind: 'material', maxStack: 1, lootable: false }));
const RARE_IDS = new Set(RARE_MOB_IDS);
export function isRareMob(mobId) {
    return RARE_IDS.has(mobId);
}
/** The wandering rare of a biome. */
export function rareOfBiome(biome) {
    const found = RARE_MOB_IDS.find((id) => RARE_MOBS[id].biome === biome);
    if (found === undefined)
        throw new Error(`no rare for ${biome}`);
    return found;
}
//# sourceMappingURL=rare-mobs.js.map